module.exports = __webpack_public_path__ + "img/dr-Rahim.a0e93aa4.jpg";